export const workerCollectionName = 'workers'
export const workerRolesCollectionName = 'workerRoles'
export const gdeWorkerRoleName = 'gde'

export const loginType = 'login'
